/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export default function Tabs () {
    return {
        MuiTabs: {
            styleOverrides: {
                vertical: {
                    overflow: "visible",
                },
            },
        },
    };
}
